<div class="app-es-ocr-quick-fix-invoice-main-details">
  <div class="app-es-ocr-quick-fix-invoice-main-details__row">
    <!--Invoice Main Details-->
    <app-section-form-block-layout
      [formGroup]="formGroup"
      [fields]="invoiceMainDetailsFields"
      headerTitle="INVOICE_MAIN_DETAILS"
      [isHeaderTitleUpperCase]="true"
      infoTooltip="FORM_HELPER.ITEM_DESCRIPTION"
      [displayFields]="invoiceMainDetailsDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(invoiceMainDetailsFields)"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    ></app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isShowClearFormButton">
    <hr class="app-es-ocr-quick-fix-invoice-main-details__hr" />

    <div class="app-es-ocr-quick-fix-invoice-main-details__clear-form-btn" (click)="clearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <custom-modal [header]="'ENTRY_SUMMARY.CHANGE_CURRENCY_SETTINGS_TITLE'" [(open)]="isWarningCurrencyModalOpen">
    <div [innerHTML]="'ENTRY_SUMMARY.CHANGE_CURRENCY_SETTINGS_WARNING' | translate"></div>
    <button footer-action type="button" class="btn btn-primary" (click)="onSubmit(false)">
      {{ "BUTTON.CONTINUE" | translate }}
    </button>
    <button footer-action type="button" class="btn btn-secondary" (click)="resetCurrency()">{{ "BUTTON.CANCEL" | translate }}</button>
  </custom-modal>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
